import { Router } from '@angular/router';
import { Ferme } from './../../../models/ferme.model';
import { FermeService } from './../../../services/ferme.service';
import { Component, OnDestroy, Input, ViewChild } from '@angular/core';
import { delay, withLatestFrom, takeWhile } from 'rxjs/operators';
import {
  NbMediaBreakpoint,
  NbMediaBreakpointsService,
  NbMenuItem,
  NbMenuService,
  NbSidebarService,
  NbThemeService,
  NbPopoverDirective,
} from '@nebular/theme';

import { StateService } from '../../../@core/utils';
import { findReadVarNames } from '@angular/compiler/src/output/output_ast';

// TODO: move layouts into the framework
@Component({
  selector: 'ngx-sample-layout',
  styleUrls: ['./sample.layout.scss'],
  templateUrl: './sample.layout.html',
})
export class SampleLayoutComponent implements OnDestroy {

  subMenu: NbMenuItem[] = [
    {
      title: 'PAGE LEVEL MENU',
    },
  ];
  layout: any = {};
  sidebar: any = {};
  fermes: Ferme[];
  selectedFerme: Ferme;
  private alive = true;
  @ViewChild(NbPopoverDirective) popover: NbPopoverDirective;
  currentTheme: string;

  constructor(protected stateService: StateService,
              protected menuService: NbMenuService,
              protected themeService: NbThemeService,
              protected bpService: NbMediaBreakpointsService,
              protected sidebarService: NbSidebarService,
              protected router: Router,
              protected fermeService: FermeService) {
    this.stateService.onLayoutState()
      .pipe(takeWhile(() => this.alive))
      .subscribe((layout: string) => this.layout = layout);

    this.stateService.onSidebarState()
      .pipe(takeWhile(() => this.alive))
      .subscribe((sidebar: string) => {
        this.sidebar = sidebar;
      });

    const isBp = this.bpService.getByName('is');
    this.menuService.onItemSelect()
      .pipe(
        takeWhile(() => this.alive),
        withLatestFrom(this.themeService.onMediaQueryChange()),
        delay(20),
      )
      .subscribe(([item, [bpFrom, bpTo]]: [any, [NbMediaBreakpoint, NbMediaBreakpoint]]) => {

        if (bpTo.width <= isBp.width) {
          this.sidebarService.collapse('menu-sidebar');
        }
      });

    this.themeService.getJsTheme()
      .pipe(takeWhile(() => this.alive))
      .subscribe(theme => {
        this.currentTheme = theme.name;
    });
  }

  selectFerme(ferme: Ferme) {
    this.fermeService.selectFerme(ferme);
    this.selectedFerme = ferme;
    this.router.navigate(['/pages/dashboard']);
    this.popover.hide();
  }

  ngOnDestroy() {
    this.alive = false;
  }
}
